import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { apolloProvider } from './core/graphql/apollo.config';

import { AppComponent } from './app.component';

import { SharedModule } from './shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule } from '@angular/common/http';
import { GraphQLModule } from './grapql.module';
import { ApolloModule } from 'apollo-angular';
import { TabSessionService } from './core/services/tab-session.service';

export function initializeTabSession(tabSessionService: TabSessionService) {
  return () => tabSessionService.initialize();
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
    HttpClientModule,
    GraphQLModule,
    ApolloModule
  ],
  providers: [
    apolloProvider,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeTabSession,
      deps: [TabSessionService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
